import { makeDefineActions } from '../../../../ui/components/pure/actions-button/actions-button.helpers';
import { ActionsButtonItem } from '../../../../ui/components/pure/actions-button/actions-button.types';
import { Download } from '../../../../ui/components/pure/icons/Download.icon';

export enum OrdersListActions {
  BOOK_ORDER = 'BOOK_ORDER',
  BOOK_ORDER_SUCESS = 'BOOK_ORDER_SUCESS',
  BOOK_AND_DELIVER_ORDER_SUCCESS = 'BOOK_AND_DELIVER_ORDER_SUCCESS',
  DOWNLOAD_CSV = 'DOWNLOAD_CSV'
}

function makeOrdersListActions(): ActionsButtonItem<OrdersListActions>[] {
  return [
    {
      title: 'Download as CSV',
      Icon: Download,
      action: OrdersListActions.DOWNLOAD_CSV
    }
  ];
}

export function makeDefineOrdersListActions() {
  return makeDefineActions(makeOrdersListActions());
}
